/* GENERATED — do not edit by hand.
 *
 * Source:    config/design-tokens.json (the semantic colour SSOT, 64 roles)
 * Generator: scripts/generate-design-tokens.mjs  (`--check` in the gates fails on drift)
 * Consumer:  src/styles/theme.ts emits every role as --color-<name>: the light
 *            values in :root, the dark values in :root[data-theme="dark"].
 *
 * A value here is the DEFINITION of a role, the same way brandColors in
 * theme.ts is the definition of a brand constant — which is why this file is
 * sanctioned in scripts/codemod-design-tokens.mjs EXCLUDED. Everything else
 * reads var(--color-<name>).
 *
 * Direction: the pavilion — 06 glass pavilion, revamped (D-0, Miles 2026-09-23)
 * Themes:    light = "noon", dark = "dusk"
 */

export const DESIGN_TOKENS_VERSION = 2;

export const SEMANTIC_TOKEN_NAMES = [
  'canvas',
  'stone',
  'water',
  'water-deep',
  'well',
  'ink',
  'ink-2',
  'ink-3',
  'placeholder',
  'line',
  'hairline',
  'line-strong',
  'line-control',
  'accent',
  'accent-hover',
  'accent-ink',
  'accent-text',
  'accent-subtle',
  'gold-sky',
  'gold-hi',
  'gold-mid',
  'gold-label-floor',
  'gold-lo',
  'gold-edge',
  'gold-spec',
  'gold-streak',
  'focus-ring',
  'danger-ink',
  'danger-bg',
  'danger-line',
  'danger-fill',
  'danger-fill-ink',
  'success-ink',
  'success-bg',
  'success-line',
  'warning-ink',
  'warning-bg',
  'warning-line',
  'scrim',
  'glass-veil',
  'glass-liquid-centre',
  'glass-liquid-rim',
  'glass-rising',
  'glass-frost',
  'glass-smoke',
  'glass-edge-hi',
  'glass-edge-tint',
  'glass-rim',
  'smoke-ink',
  'smoke-ink-2',
  'smoke-ink-3',
  'smoke-accent-text',
  'smoke-edge',
  'slab',
  'slab-hi',
  'slab-lo',
  'slab-ink',
  'meniscus',
  'meniscus-hi',
  'shadow-ink',
  'shadow-0',
  'shadow-1',
  'shadow-2',
  'shadow-3',
] as const;

export type SemanticTokenName = (typeof SEMANTIC_TOKEN_NAMES)[number];
export type SemanticTokens = Record<SemanticTokenName, string>;

export const semanticLight: SemanticTokens = {
  'canvas'              : '#FAFAF8',
  'stone'               : '#E9E4DA',
  'water'               : '#E4DFD4',
  'water-deep'          : '#DDD6C8',
  'well'                : '#F1EEE7',
  'ink'                 : '#111111',
  'ink-2'               : '#4A4A4A',
  'ink-3'               : '#66615A',
  'placeholder'         : '#656A6F',
  'line'                : 'rgba(17,17,17,0.12)',
  'hairline'            : 'rgba(17,17,17,0.08)',
  'line-strong'         : '#D0D0D0',
  'line-control'        : '#7F7A70',
  'accent'              : '#C6A75E',
  'accent-hover'        : '#B6924C',
  'accent-ink'          : '#2B2B2B',
  'accent-text'         : '#7a6125',
  'accent-subtle'       : 'rgba(198,167,94,0.10)',
  'gold-sky'            : '#E4CE90',
  'gold-hi'             : '#D3B770',
  'gold-mid'            : '#BC9D53',
  'gold-label-floor'    : '#B8974C',
  'gold-lo'             : '#AF9048',
  'gold-edge'           : '#7A6430',
  'gold-spec'           : 'rgba(255,255,255,0.58)',
  'gold-streak'         : 'rgba(255,255,255,0.42)',
  'focus-ring'          : '#7a6125',
  'danger-ink'          : '#B42318',
  'danger-bg'           : '#FDECEC',
  'danger-line'         : '#F2B8B5',
  'danger-fill'         : '#C93B3B',
  'danger-fill-ink'     : '#FFFFFF',
  'success-ink'         : '#2F6B3A',
  'success-bg'          : '#EAF7EF',
  'success-line'        : '#A7D7B8',
  'warning-ink'         : '#7A5C00',
  'warning-bg'          : '#FFF8E6',
  'warning-line'        : '#E8DFC4',
  'scrim'               : 'rgba(28,25,23,0.38)',
  'glass-veil'          : 'rgba(250,250,248,0.18)',
  'glass-liquid-centre' : 'rgba(255,255,255,0.30)',
  'glass-liquid-rim'    : 'rgba(255,255,255,0.60)',
  'glass-rising'        : 'rgba(250,250,248,0.55)',
  'glass-frost'         : 'rgba(250,250,248,0.70)',
  'glass-smoke'         : 'rgba(28,27,25,0.84)',
  'glass-edge-hi'       : 'rgba(255,255,255,0.95)',
  'glass-edge-tint'     : 'rgba(96,128,118,0.26)',
  'glass-rim'           : 'rgba(17,17,17,0.12)',
  'smoke-ink'           : '#FAFAF8',
  'smoke-ink-2'         : '#E6E2DB',
  'smoke-ink-3'         : '#BDB7AD',
  'smoke-accent-text'   : '#E8C87A',
  'smoke-edge'          : 'rgba(255,255,255,0.16)',
  'slab'                : '#2B2B2B',
  'slab-hi'             : '#3A3A3A',
  'slab-lo'             : '#1A1A1A',
  'slab-ink'            : '#FAFAF8',
  'meniscus'            : 'rgba(17,17,17,0.20)',
  'meniscus-hi'         : 'rgba(255,255,255,0.70)',
  'shadow-ink'          : '30,25,20',
  'shadow-0'            : 'inset 0 2px 6px rgba(30,25,20,0.16), inset 0 1px 0 rgba(0,0,0,0.06), inset 0 -1px 0 rgba(255,255,255,0.60)',
  'shadow-1'            : '0 1px 1px rgba(30,25,20,0.10), 6px 14px 28px -10px rgba(30,25,20,0.28), 12px 40px 70px -30px rgba(30,25,20,0.30)',
  'shadow-2'            : '0 1px 1px rgba(30,25,20,0.10), 8px 18px 36px -12px rgba(30,25,20,0.30), 18px 56px 96px -36px rgba(30,25,20,0.34)',
  'shadow-3'            : '0 2px 2px rgba(30,25,20,0.12), 12px 28px 56px -16px rgba(30,25,20,0.38), 28px 80px 140px -44px rgba(30,25,20,0.42)',
};

export const semanticDark: SemanticTokens = {
  'canvas'              : '#111111',
  'stone'               : '#1C1A17',
  'water'               : '#191714',
  'water-deep'          : '#171512',
  'well'                : '#161616',
  'ink'                 : '#FAFAF8',
  'ink-2'               : '#D6D2CB',
  'ink-3'               : '#A8A297',
  'placeholder'         : '#A19B91',
  'line'                : 'rgba(250,250,248,0.12)',
  'hairline'            : 'rgba(250,250,248,0.08)',
  'line-strong'         : '#4A4A4A',
  'line-control'        : '#7A766D',
  'accent'              : '#C8A75E',
  'accent-hover'        : '#D4B76F',
  'accent-ink'          : '#2B2B2B',
  'accent-text'         : '#E8C87A',
  'accent-subtle'       : 'rgba(200,167,94,0.15)',
  'gold-sky'            : '#DCC585',
  'gold-hi'             : '#CCAF67',
  'gold-mid'            : '#B5944D',
  'gold-label-floor'    : '#B4934A',
  'gold-lo'             : '#A38443',
  'gold-edge'           : '#4E3F1C',
  'gold-spec'           : 'rgba(255,255,255,0.44)',
  'gold-streak'         : 'rgba(255,255,255,0.36)',
  'focus-ring'          : '#C8A75E',
  'danger-ink'          : '#FF7B72',
  'danger-bg'           : 'rgba(255,123,114,0.12)',
  'danger-line'         : 'rgba(255,123,114,0.40)',
  'danger-fill'         : '#C93B3B',
  'danger-fill-ink'     : '#FFFFFF',
  'success-ink'         : '#6FD98A',
  'success-bg'          : 'rgba(111,217,138,0.12)',
  'success-line'        : 'rgba(111,217,138,0.35)',
  'warning-ink'         : '#F2C94C',
  'warning-bg'          : 'rgba(242,201,76,0.12)',
  'warning-line'        : 'rgba(242,201,76,0.35)',
  'scrim'               : 'rgba(0,0,0,0.55)',
  'glass-veil'          : 'rgba(26,26,26,0.18)',
  'glass-liquid-centre' : 'rgba(255,255,255,0.05)',
  'glass-liquid-rim'    : 'rgba(255,255,255,0.14)',
  'glass-rising'        : 'rgba(26,26,26,0.50)',
  'glass-frost'         : 'rgba(26,26,26,0.72)',
  'glass-smoke'         : 'rgba(18,18,18,0.78)',
  'glass-edge-hi'       : 'rgba(255,255,255,0.26)',
  'glass-edge-tint'     : 'rgba(140,170,160,0.16)',
  'glass-rim'           : 'rgba(0,0,0,0.55)',
  'smoke-ink'           : '#FAFAF8',
  'smoke-ink-2'         : '#E6E2DB',
  'smoke-ink-3'         : '#A8A297',
  'smoke-accent-text'   : '#E8C87A',
  'smoke-edge'          : 'rgba(255,255,255,0.12)',
  'slab'                : '#232323',
  'slab-hi'             : '#333333',
  'slab-lo'             : '#0D0D0D',
  'slab-ink'            : '#FAFAF8',
  'meniscus'            : 'rgba(255,255,255,0.14)',
  'meniscus-hi'         : 'rgba(255,255,255,0.05)',
  'shadow-ink'          : '0,0,0',
  'shadow-0'            : 'inset 0 2px 6px rgba(0,0,0,0.50), inset 0 1px 0 rgba(0,0,0,0.40), inset 0 -1px 0 rgba(255,255,255,0.06)',
  'shadow-1'            : '0 0 0 1px rgba(255,255,255,0.04), 0 18px 40px -12px rgba(0,0,0,0.80), 0 1px 0 rgba(255,255,255,0.05)',
  'shadow-2'            : '0 0 0 1px rgba(255,255,255,0.05), 0 24px 60px -14px rgba(0,0,0,0.85)',
  'shadow-3'            : '0 0 0 1px rgba(255,255,255,0.06), 0 40px 100px -20px rgba(0,0,0,0.90)',
};
